import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SidebarMenuComponent } from './sidebar-menu.component'
import { RouterModule } from '@angular/router'
import { ProjectsMenuModule } from './components/projects-menu'
import { ChatMenuModule } from './components/chat-menu'
import { EffectsModule } from '@ngrx/effects'
import { FavoriteProjectsEffects } from '@app/projects-module/state/favorite-projects/favorite-projects.effects'
import { UpdateFavoriteProjectSortCommand } from '@app/projects-module/core/commands/update-favorite-project-sort.command'
import { FavoriteProjectsStoreFacade } from '@app/projects-module/state/favorite-projects/favorite-projects-store.facade'
import { StreamMenuModule } from './components/stream-menu'
import { AvatarModule } from '../avatar'
import { SignOutServiceModule } from '@app/shared/services/sign-out'
import { OrganizationsMenuModule } from './components/organizations-menu'
import { NgScrollbarModule } from 'ngx-scrollbar'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ProjectsMenuModule,
    StreamMenuModule,
    ChatMenuModule,
    EffectsModule.forFeature([FavoriteProjectsEffects]),
    AvatarModule,
    SignOutServiceModule,
    OrganizationsMenuModule,
    NgScrollbarModule,
  ],
  declarations: [SidebarMenuComponent],
  exports: [SidebarMenuComponent],
  providers: [FavoriteProjectsStoreFacade, UpdateFavoriteProjectSortCommand],
})
export class SidebarMenuModule {}
